import { render, staticRenderFns } from "./StockReportPrint.vue?vue&type=template&id=fb7c2964&"
import script from "./StockReportPrint.vue?vue&type=script&lang=js&"
export * from "./StockReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports